<!-- src/app/pages/cost-metrics/cost-analysis/cost-analysis.html -->
<div class="costAnalysis">
    <div class="grid grid-cols-12 gap-4">
        @for (card of data.cards; track card) {
        <div class="col-span-12 chartWrap lg:col-span-4">
            <div class="rounded-2xl p-4 md:p-6">
                <div class="flex items-center justify-between">
                    <h2 class="font-semibold text-lg">{{ card.title }}</h2>
                </div>
                <div class="mt-4">
                    <p-chart type="bar" [data]="card.chartData" [options]="card.chartOptions" class="w-full h-44 md:h-52"></p-chart>
                </div>
                <div class="dashboardHide scenerioTable">
                    <div class="mt-3 space-y-3 text-sm">
                        <table class="table-auto">
                            <thead>
                                <tr>
                                    <th>Scenerio Comparison</th>
                                    <th>Base</th>
                                    <th>Current</th>
                                </tr>
                            </thead>
                            <tbody>
                                @for (r of card.rows; track r) {
                                <tr>
                                    <td>{{ r.label }}</td>
                                    <td>{{ r.base }}</td>
                                    <td>{{ r.scenario }}</td>
                                </tr>
                                }
                                <tr>
                                    <td>TOTAL</td>
                                    <td>{{ card.total.base }}</td>
                                    <td>{{ card.total.scenario }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="my-4 border-t border-slate-200"></div>
                </div>
            </div>
        </div>
        }
    </div>
</div>
